<template>
    <div class="relative block">
        <LoaderCircle v-if="!loaded"
                      :size="14"
                      class="absolute left-4 top-1/2 -translate-y-1/2 animate-spin text-slate-400"
        />
        <select name="calendar-category-filter" id="calendar-category-filter"
                class="rounded-xl bg-white border border-slate-300 px-4 py-2.5 w-[100%] transition-all duration-150 ease-out"
                :class="{'cursor-not-allowed pl-[30px] text-slate-400': !loaded, 'bg-white': loaded}"
                :disabled="!loaded"
                v-model="model"
        >

            <option :value="null">{{ $t('Velg klasse') }}</option>
            <option :value="category.id" v-for="category in categories">{{ category.name }}</option>
        </select>
    </div>
</template>

<script setup>
    import {LoaderCircle} from 'lucide-vue-next';
    import {ref, watchEffect} from 'vue';

    const model = defineModel()

    const {categories} = defineProps({
        categories: {
            type: Array,
            required: true
        }
    })

    const loaded = ref(false);

    watchEffect(() => {
        loaded.value = categories.length > 0;
    })
</script>